import { render } from "./HappsIcon.vue?vue&type=template&id=05434a4a&scoped=true"
import script from "./HappsIcon.vue?vue&type=script&lang=js"
export * from "./HappsIcon.vue?vue&type=script&lang=js"

import "./HappsIcon.vue?vue&type=style&index=0&id=05434a4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05434a4a"

export default script